"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Section = styled_components_1.default.div `
	margin-top: 2rem;
`;
const SectionTitle = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray8};
	margin-bottom: 1rem;
	font-size: 1rem;
`;
const ReportSection = ({ title, children }) => {
    return ((0, jsx_runtime_1.jsxs)(Section, { children: [(0, jsx_runtime_1.jsx)(SectionTitle, { children: title }), (0, jsx_runtime_1.jsx)(elements_1.Panel, { className: "p-none", children: children })] }));
};
exports.default = ReportSection;
